import { render, staticRenderFns } from "./QueryClaimHeader.vue?vue&type=template&id=03fc250e&"
import script from "./QueryClaimHeader.vue?vue&type=script&lang=js&"
export * from "./QueryClaimHeader.vue?vue&type=script&lang=js&"
import style0 from "./QueryClaimHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports